/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import ObservationsObservation from './ObservationsObservation';

/**
 * The ObservationsBody model module.
 * @module model/ObservationsBody
 * @version v0.3
 */
export default class ObservationsBody {
  /**
   * Constructs a new <code>ObservationsBody</code>.
   * @alias module:model/ObservationsBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>ObservationsBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ObservationsBody} obj Optional instance to populate.
   * @return {module:model/ObservationsBody} The populated <code>ObservationsBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new ObservationsBody();
      if (data.hasOwnProperty('observation'))
        obj.observation = ObservationsObservation.constructFromObject(data['observation']);
    }
    return obj;
  }
}

/**
 * @member {module:model/ObservationsObservation} observation
 */
ObservationsBody.prototype.observation = undefined;

